import styled from 'styled-components';
import { H6 } from '../texts';

const Container = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;

  h4 {
    margin-left: 30px;
    margin-bottom: 20px;
  }

  * {
    box-sizing: border-box;
  }
`;
const BlockDescription = styled.div<any>`
  max-height: ${p => (!p.isOpen ? 0 : 'auto')};
  padding: ${p => (p.isOpen ? '20px' : '0 20px')};
  border-top: ${p => `${p.isOpen ? 10 : 0}px solid ${p.theme.color.pale}`};
  transition-property: max-height, height, border-top, padding;
  transition-timing-function: linear, ease;
  transition-duration: ${p => p.theme.duration.s};
  overflow: hidden;
  position: relative;
`;

const Block = styled.div`
  width: 100%;
  border-radius: 30px;
  background-color: ${p => p.theme.color.backgroundRush};
  box-shadow: ${props => props.theme.shadow.s};
  margin-bottom: 10px;
`;

const DescriptionTextContainer = styled.div<any>`
  opacity: ${p => (p.isOpen ? 1 : 0)};
  transition-property: opacity;
  transition-timing-function: linear, ease;
  transition-duration: ${p => p.theme.duration.s};

  ${H6} {
    font-size: 16px;
  }
`;
const ArrowContainer = styled.div<any>`
  width: 100%;
  height: 100%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  svg {
    transition: all ${p => p.theme.duration.s} linear;
    height: 20px;
    width: 20px;
    fill: ${p => p.theme.color.gray};
    transform: rotate(${p => p.isOpen && '90deg'});
    margin-right: 20px;
  }
`;
const BlockHeader = styled.div`
  width: 100%;
  padding: 20px;
  display: grid;
  grid-template-columns: 40px 1fr;
  cursor: pointer;
  position: relative;
  border-radius: 30px;

  :hover {
    svg {
      fill: ${p => p.theme.color.turquoise};
    }
  }
`;

export const Styled = {
  Container,
  Block,
  BlockDescription,
  DescriptionTextContainer,
  ArrowContainer,
  BlockHeader,
};
